module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bonnie O’Neil, Gary Scheiner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Bonnie O’Neil")]), _vm._v(" has a son and two siblings with type 1 diabetes (T1D) and is an active board member and strategic leader of the founding chapter of JDRF (Juvenile Diabetes Research Foundation), the world’s leading funder of research to cure, prevent, and treat T1D. As a member of JDRF’s National Speakers Bureau, Bonnie is a featured presenter at education conferences throughout the T1D community. She has contributed essays on raising a child with T1D to the heavily trafficked diabetes website "), _c('I', [_vm._v("BeyondType1")]), _vm._v(" where her articles typically reach between 20-32K readers with high engagement. Bonnie is a spiritual director, the Executive Director of Alpha Mid Atlantic, and lives in suburban Philadelphia.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ckghtw/tc-custom/9781631952296.jpg?1728353438601",
      "alt": "This image is the cover for the book Chronic Hope"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chronic Hope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Chronic Hope")]), _vm._v(" helps parents of children living with chronic disease gain practical wisdom for managing the emotional stress of raising a chronically ill child, so they can navigate these challenges with grace, courage, and love.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0